import { FC } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { AppRoutes } from "../../../constants/routes";
import { Typography } from "../typography/Typography";
import { TypographyVariant } from "../typography/Typography.interface";

const Container = styled.div`
  position: sticky;
  top: 76px;
  z-index: 4;
  width: 100%;
  background: linear-gradient(
    270deg,
    #7914c9 12.33%,
    #af14c9 99.99%,
    #af14c9 100%
  );

  display: flex;
  flex-direction: column;
  /* align-items: center;
  justify-content: center; */
  padding: 7px;
`;

// const Text = styled.span`
//   font-family: Montserrat;
//   font-weight: 500;
//   font-size: 13px;
//   color: #ffffff;
//   @media (max-width: 900px) {
//     text-align: center;
//   }
// `;

// const StyledText = styled(Text)`
//   max-width: 1000px;
//   text-align: center;
// `;

// const Link = styled.a`
//   font-family: Montserrat;
//   font-weight: 500;
//   font-size: 13px;
//   color: #ffffff;
//   &:hover {
//     text-decoration: underline;
//     cursor: pointer;
//   }
//   @media (max-width: 900px) {
//     text-align: center;
//   }
// `;

// const Link = styled.span`
//   color: #2cd19e;
//   cursor: pointer;
// `;

const Dot = styled.span`
  color: #2cd19e;
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  line-height: 0;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MaintainBtn = styled.button`
  font-family: Montserrat;
  font-style: normal;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 13px;
  background-color: rgba(19, 39, 63, 0.5);
  line-height: 16px;
  padding: 3px 12px;
  color: #ffffff;
  border: none;
  font-weight: 600;
  &:hover {
    background-color: #19385e;
  }
`;

// const SpanBtn = styled(Text)`
//   text-decoration: underline;
//   cursor: pointer;
//   transition: 0.3s;
//   :hover {
//   }
// `;

const MissingDataBanner: FC = () => {
  // const { bankConsentExpired }: any = company;
  const navigate = useNavigate();
  const maintainConnection = () => {
    navigate(AppRoutes.Private.Settings.BANK_ACCOUNTS);
  };

  // const onMaintainSuccess = async () => {
  //   await refreshCompany();
  // };

  // const goToVerification = () => {
  //   if (companyType === CompanyTypes.COMPANY) {
  //     router.push("/register/business/limited/director");
  //   } else {
  //     dispatch(
  //       setCompanyData({
  //         selectedOfficerId: company.directors?.[0]._id,
  //       })
  //     );
  //     router.push("/register/verification");
  //   }
  // };

  // const renderOptions = () => {
  // if (bankAccountRequired && idVerificationRequired) {
  //   return (
  //     <Text>
  //       {startedVerification
  //         ? 'You still need to add a bank account to complete the sign-up process and start taking payments.'
  //         : ' ID verification and bank account connection is necessary before you can start taking payments.'}
  //       {` `}
  //       <Link
  //         onClick={() => {
  //           if (startedVerification) {
  //             router.push(ROUTES.MANAGE_BANK_ACCOUNT);
  //           } else {
  //             goToVerification();
  //           }
  //         }}
  //       >
  //         Complete account setup
  //       </Link>
  //     </Text>
  //   );
  // }
  // if (bankAccountRequired) {
  //   return (
  //     <Text>
  //       You need to connect a bank account before you can start taking
  //       payments.&nbsp;
  //       <Link
  //         onClick={() => {
  //           router.push(ROUTES.MANAGE_BANK_ACCOUNT);
  //         }}
  //       >
  //         Complete account setup
  //       </Link>
  //     </Text>
  //   );
  // } else if (idVerificationRequired) {
  //   return (
  //     <Text>
  //       {startedVerification
  //         ? 'Your account verification is in progress. We’ll be in touch when it’s ready to use.'
  //         : 'ID Verification is necessary before you can start taking payments'}
  //       {` `}
  //       {!startedVerification && (
  //         <Link
  //           onClick={() => {
  //             router.push(ROUTES.BUSINESS_DETAILS);
  //           }}
  //         >
  //           Complete account setup
  //         </Link>
  //       )}
  //     </Text>
  //   );
  // }
  // };

  return (
    <Container>
      <Row>
        {/* At 30 days */}
        <Typography variant={TypographyVariant.BODY4} color="#fff">
          In order to provide alerts for missed or cancelled payments, please
          confirm you’re happy for us to maintain connection to your bank
          account
        </Typography>
        <Dot>&#x2022;</Dot>
        <MaintainBtn onClick={maintainConnection}>
          Maintain connection
        </MaintainBtn>

        {/* 14 days */}
        {/* <Text>
            We’ll soon not be able to to provide alerts for missed or cancelled
            payments. To continue benefitting, please confirm you’re happy for
            us to maintain connection to your bank account
          </Text>
          <Dot>&#x2022;</Dot>
          <MaintainBtn onClick={maintainConnection} variant="contained">
            Maintain connection
          </MaintainBtn> */}

        {/* 1 day */}
        {/* <Text>
            You’re about to lose alerts for missed or cancelled payments. To
            continue benefitting, please confirm you’re happy for us to maintain
            connection to your bank account
          </Text>
          <Dot>&#x2022;</Dot>
          <MaintainBtn onClick={maintainConnection} variant="contained">
            Maintain connection
          </MaintainBtn> */}

        {/* After 90 days */}
        {/* <StyledText>
            Fena can no longer provide alerts for missed or cancelled payments.
            If you’d like these checks,{' '}
            <SpanBtn>please reconnect your account</SpanBtn>, otherwise, hit{' '}
            <SpanBtn>dismiss</SpanBtn>. You can always reconnect your account
            from Settings &gt; Bank accounts
          </StyledText> */}
      </Row>
      {/* // ) : (
        //   <Row>
        //     <Text>
        //       You can only create sandbox payments until the following issues are
        //       resolved:
        //     </Text>{" "}
        //     {company.bankAccounts?.filter((i) => !i.isSandbox).length === 0 ? ( */}
      {/* //       <>
        //         <Dot>&#x2022;</Dot>
        //         <Link onClick={() => router.push(ROUTES.MANAGE_BANK_ACCOUNT)}>
        //           Please add a bank account&nbsp;
        //         </Link>
        //       </>
        //     ) : !company.bankAccounts?.find(
        //         (ba: BankAccount) =>
        //           ba.status === BankAccountStatus.VERIFIED && !ba.isSandbox
        //       ) && company.integrations?.length !== 0 ? (
        //       <>
        //         <Dot>&#x2022;</Dot>
        //         <Text>Bank account verification is in progress&nbsp;</Text>{" "}
        //       </>
        //     ) : (
        //       <></>
        //     )}
        //     {!user?.emailVerified && ( */}
      {/* //       <>
        //         <Dot>&#x2022;</Dot>
        //         <Link onClick={() => router.push(ROUTES.PROFILE)}>
        //           Please verify your email address&nbsp;
        //         </Link>
        //       </>
        //     )}
        //     {company.status === CompanyStatus.PENDING_VERIFICATION ? ( */}
      {/* //       <>
        //         <Dot>&#x2022;</Dot>
        //         <Link onClick={() => goToVerification()}>
        //           Please complete ID verification&nbsp;
        //         </Link>
        //       </>
        //     ) : company.status === CompanyStatus.ACTIVE ? (
        //       <></>
        //     ) : (
        //       <>
        //         <Dot>&#x2022;</Dot>
        //         <Text>ID verification is in progress&nbsp;</Text>
        //       </>
        //     )}
        //   </Row> */}
    </Container>
  );
};

export default MissingDataBanner;
